const MEDIA_URL = "https://api.ragminds.com/media";
const API_URL = "https://api.ragminds.com";

// const API_URL = "http://127.0.0.1:8001";
// const MEDIA_URL = `${API_URL}/media`;

export { MEDIA_URL, API_URL };